import React, { Fragment,useState } from "react";
import { Dropdown, Container, Form, Nav, Navbar, InputGroup, } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import { auth } from "../../Firebase/firebase";
import Searchable from "react-searchable-dropdown";
import { useDispatch } from 'react-redux';
import { deleteUserData } from '../../store/actions';
import { deleteConfigDataSystem } from '../../store/actions4';
import { resetMenu } from '../../store/actions2';
import useDarkMode from '../../hooks/useDarkMode';
import { meetingRoomPages } from '../../menu';
import { useSelector } from 'react-redux';
import TopMenu from '../../layouts/Menu/TopMenu'
import {
  logout
} from "../../api/common_java";

// import { paperlessPages } from '../../menu';
 //定时器
// const intervalId = setInterval(function() {
//   // console.log("执行了一次");
//   //timingAddMeeting();
// }, 30000); // 2000毫秒 = 2秒
// FuScreen-start
function Fullscreen() {
  if (
    (document.fullScreenElement && document.fullScreenElement === null) ||
    (!document.mozFullScreen && !document.webkitIsFullScreen)
  ) {
    if (document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen(
        Element.ALLOW_KEYBOARD_INPUT
      );
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
}
// FullScreen-end
function Header() {
  // 用户信息
	const userData = useSelector((state) => state.userData);
  // console.log(userData)

  const dispatch = useDispatch();
  const { darkModeStatus, setDarkModeStatus } = useDarkMode();

  let navigate = useNavigate();
  const routeChange = async () => {
    await logout();
    dispatch(deleteUserData());
    dispatch(resetMenu());
    dispatch(deleteConfigDataSystem());
    dispatch()
    let path = `${process.env.PUBLIC_URL}/login`;
    navigate(path);
  }

  const openCloseSidebar1 = () => {
    document.querySelector(".header-settings").classList.toggle("show");
    document.querySelector(".sidebar-right").classList.toggle("sidebar-open");
  };
  //  headerToggleButton
  const headerToggleButton = () => {
    let body = document.querySelector("body");
    let innerWidth = window.innerWidth;
    if (body !== !body) {
      if (innerWidth >= 992) {
        document.querySelector("body")?.classList.toggle("main-sidebar-hide");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
      } else if (document.body.classList.contains("horizontalmenu")) {
        document.querySelector("body")?.classList.toggle("main-navbar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      } else {
        document.querySelector("body")?.classList.toggle("main-sidebar-show");
        document.querySelector("body")?.classList.remove("main-sidebar-hide");
      }
    }
  };

  function Swicherbutton() {
    document.querySelector(".demo_changer").classList.toggle("active");
    document.querySelector(".demo_changer").style.right = "0px";
  }
  const Darkmode = () => {
    setDarkModeStatus(!darkModeStatus)
    document.querySelector("body").classList.toggle("dark-theme");
  };
  return (
    <Fragment>
      <Navbar
        expand="lg"
        className="main-header sticky ps-0">
        <Container fluid className="main-container container-fluid">
          <div className="main-header-left">
            <Link
              to="#"
              className="main-header-menu-icon"
              id="mainSidebarToggle"
              onClick={() => headerToggleButton()}
            >
              <span></span>
            </Link>
          </div>
          <div className="main-header-center" style={{ overflow: 'hidden', fontSize:'16px' }}>
            <TopMenu></TopMenu>
          </div>
          <div className="main-header-right">
            <Navbar.Toggle
              aria-controls="navbarSupportedContent-4"
              className="navresponsive-toggler"
            >
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </Navbar.Toggle>
            <div className="navbar navbar-expand-lg nav nav-item navbar-nav-right responsive-navbar navbar-dark">
              <Navbar.Collapse
                className="collapse navbar-collapse"
                id="navbarSupportedContent-4"
              >
                <div className="d-flex order-lg-2 align-items-center ms-auto">
                  <Dropdown className="header-search">
                    <Dropdown.Toggle variant="default" className="px-0">
                      <i className="fe fe-search header-icons fs-18 px-2 lh-5"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-2">
                      <InputGroup>
                        <Searchable className="form-control select2"
                          value="test"
                          placeholder="Choose one" // by default "Search"
                          notFoundText="No result found" // by default "No result found"
                          noInput
                          options={[
                            {
                              value: "",
                              label: "All categories"

                            },
                            {
                              value: "it projects",
                              label: "IT Projects"
                            },
                            {
                              value: "business case",
                              label: "Business Case"
                            },
                            {
                              value: "microsoft project",
                              label: "Microsoft Project"
                            },
                            {
                              value: "risk ]management",
                              label: "Risk Management"
                            },
                            {
                              value: "popular",
                              label: "Popular"
                            },
                            {
                              value: "team building",
                              label: "Team Building"
                            },
                          ]}
                          onSelect={(value) => {
                            // console.log(value);
                          }}
                          listMaxHeight={140} //by default 140
                        />
                        <Form.Control
                          type="search"
                          className="rounded-0"
                          placeholder="Search for anything..."
                        />
                        <InputGroup.Text className="btn search-btn">
                          <i className="fe fe-search"></i>
                        </InputGroup.Text>
                      </InputGroup>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown className="dropdown d-flex main-header-theme">
                    <Nav.Link
                      className="nav-link icon layout-setting"
                      onClick={() => Darkmode()}
                    >
                      <span className="dark-layout">
                        <i className="fe fe-sun header-icons"></i>
                      </span>
                      <span className="light-layout">
                        <i className="fe fe-moon header-icons"></i>
                      </span>
                    </Nav.Link>
                  </Dropdown>
                  <div className="d-md-flex">
                    <div
                      className="nav-link icon full-screen-link"
                      onClick={Fullscreen}
                    >
                      <i className="fe fe-maximize fullscreen-button fullscreen header-icons"></i>
                      <i className="fe fe-minimize fullscreen-button exit-fullscreen header-icons"></i>
                    </div>
                  </div>
                  <Dropdown className="main-profile-menu">
                    <Dropdown.Toggle className="d-flex p-0" variant="default">
                      <span className="main-img-user mx-1">
                        <img
                          alt="avatar"
                          src={userData?.portrait ? `${window.location.origin}/${userData.portrait}` : require("../../assets/img/users/1.jpg")}
                          onError={(e) => {
                            e.target.src = require("../../assets/img/users/1.jpg");
                          }}
                          style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '50%' }}
                        />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ margin: "0px" }}>
                      <div className="header-navheading">
                        <h6 className="main-notification-title">
                        {userData?userData.realName:""}
                        </h6>
                        {/* <p className="main-notification-text">智能会议系统</p> */}
                      </div>
                      {/* <Dropdown.Item
                        className="border-top"
                        href={`${process.env.PUBLIC_URL}/pages/profile`}
                      >
                        <i className="fe fe-user"></i> My Profile
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`${process.env.PUBLIC_URL}/pages/profile`}
                      >
                        <i className="fe fe-edit"></i> Edit Profile
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`${process.env.PUBLIC_URL}/pages/profile`}
                      >
                        <i className="fe fe-settings"></i> Account Settings
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`${process.env.PUBLIC_URL}/pages/profile`}
                      >
                        <i className="fe fe-settings"></i> Support
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`${process.env.PUBLIC_URL}/pages/profile`}
                      >
                        <i className="fe fe-compass"></i> Activity
                      </Dropdown.Item> */}
                      <Dropdown.Item
                        onClick={() => { routeChange() }}
                      >
                        <i className="fe fe-power"></i> 退出登录
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Navbar.Collapse>
            </div>
          </div>
        </Container>
      </Navbar>
    </Fragment>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
